import { useBrandedVisitorGate } from '#pplx/frontend/apps/ask/hooks/branded-visitor-gate-hooks/useBrandedVisitorGate.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const useComputerPaywallUpsell = ({ redirectUrl, } = {}) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const { isEnterprise } = useIsSubscribed();
    const { openVisitorLoginUpsell } = useBrandedVisitorGate({
        enabled: !isUserLoggedIn,
    });
    const openPaywallUpsell = usePaywallUpsell({ redirectUrl });
    const { $t } = useIntl();
    const defaultTitle = $t({
        defaultMessage: 'Using Computer requires a Pro plan',
        description: 'Title shown in the paywall upsell modal when a user tries to use Computer features without a Pro plan',
        id: '801c3590bc',
    });
    const description = $t({
        defaultMessage: 'Upgrade your plan for the best experience with Computer features.',
        description: 'Description shown in the paywall upsell modal encouraging users to upgrade their plan for Computer features',
        id: 'fd6a4bffb9',
    });
    const loginGateTitle = $t({
        defaultMessage: 'Sign in to use Computer',
        description: 'Title shown in the login gate when a visitor tries to use Computer features',
        id: '1759fab0bc',
    });
    const loginGateDescription = $t({
        defaultMessage: 'Offload and automate your work.',
        description: 'Description shown in the login gate encouraging visitors to sign in to access Perplexity Computer',
        id: 'e92ca188e8',
    });
    const workflowsLoginGateTitle = $t({
        defaultMessage: 'Sign in to access Workflows',
        description: 'Title shown in the login gate when a visitor tries to use Workflows',
        id: '4494e83dc0',
    });
    const workflowsLoginGateDescription = $t({
        defaultMessage: 'Get expert-built workflows that research, monitor, and ship results around the clock.',
        description: 'Description shown in the login gate when a visitor tries to use Workflows',
        id: 'd528bce476',
    });
    return useCallback(({ title = defaultTitle, origin, onClose }) => {
        if (!isUserLoggedIn) {
            const isWorkflow = origin === ModalOrigin.COMPUTER_WORKFLOW;
            openVisitorLoginUpsell({
                title: isWorkflow ? workflowsLoginGateTitle : loginGateTitle,
                description: isWorkflow ? workflowsLoginGateDescription : loginGateDescription,
                origin,
            });
            return;
        }
        const segment = isEnterprise ? 'business' : 'personal';
        openPaywallUpsell({
            origin,
            highlightTier: 'pro',
            defaultSegment: segment,
            pitchMessage: {
                title,
                description,
            },
            redirectUrl,
            onClose,
        });
    }, [
        isUserLoggedIn,
        isEnterprise,
        openVisitorLoginUpsell,
        openPaywallUpsell,
        defaultTitle,
        description,
        loginGateTitle,
        loginGateDescription,
        workflowsLoginGateTitle,
        workflowsLoginGateDescription,
        redirectUrl,
    ]);
};
//# sourceMappingURL=useComputerPaywallUpsell.js.map